<script>import "./CarbonChartsStyles.css";
import { GaugeChart } from "@carbon/charts-svelte";
export let value;
export let title = "";
export let height = "250px";
export let type = "full";
export let color = "";
$: data = [
  {
    group: "value",
    value
  }
];
$: options = {
  title,
  height,
  gauge: {
    type,
    alignment: "center"
  },
  color: {
    scale: {
      value: color
    }
  },
  data: {
    loading: !data.length
  }
};
</script>

<div>
	<svelte:component this={GaugeChart} {data} {options} />
</div>

<style>div :global(.toolbar){display:none}div :global(.title){padding-right:0;text-align:center}</style>
